module.exports = __webpack_public_path__ + "robots.txt";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=robots.txt!./app/static/robots.txt
 ** module id = 928
 ** module chunks = 0
 **/